import {
  createFileRoute,
  Outlet,
  useParams,
  useLocation
} from '@tanstack/react-router'
import SideBarComponent from '../../../../../../../../../../../components/stories/molecules/sidebar'
import { useGetTaskQuery } from '../../../../../../../../../../../react-query/tasks/query/use-get-task-query.jsx'
import TaskDetails from '../../../../../../../../../../../containers/tasks/task-details/index.jsx'

function TaskDetailsLayout() {
  const { taskId } = useParams({ strict: false })
  const location = useLocation()
  const { data: taskDetails } = useGetTaskQuery(taskId)

  const baseUrl = (() => {
    const match = location.pathname.match(/^(.*\/task-details\/[^/]+)/)
    return match ? match[1] : location.pathname
  })()

  return (
    <SideBarComponent
      isOpen={true}
      style={{ zIndex: '5002', minWidth: '400px' }}
      topOffset="48px"
    >
      <TaskDetails baseUrl={baseUrl} taskDetails={taskDetails} />
      <Outlet />
    </SideBarComponent>
  )
}

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId'
)({
  component: TaskDetailsLayout
})
